export default __webpack_public_path__ + "locales/lo-LA/RoomLogoCover.json?hash=d5d56469940b4265bcaccb1fa1144f7f";